import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
  Attribute,
  isDevMode,
  HostBinding,
} from '@angular/core';
import { Option, None, Some, isNone } from './icon.type';
import { IconService } from './icons.service';
import { ICONS, Icons } from './icons';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'i-icon[name]',
  standalone: true,
  imports: [CommonModule],
  exportAs: 'iIcon',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./icons.component.scss'],
  providers: [IconService, { provide: ICONS, useValue: Icons }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconsComponent implements OnInit {

  @Input() @HostBinding('attr.role') role = 'icon';
  @HostBinding('class.i-icon') _hasBaseClass = true;

  // @Input() width = 'w-5';
  // @HostBinding('class') _width = '';
  // @Input() height = 'h-5'
  // @HostBinding('class') _height = '';


  @Input() width = 'tw-w-6';
  _width = '';
  @Input() height = 'tw-h-6'
  _height = '';



  private inlineBlockClass = 'tw-inline-block';
  private vMiddleClass = 'tw-align-middle';

  static ngAcceptInputType_name: string;

  private _name: Option<string> = None();

  @Input() class = '';

  @HostBinding('class') get hostClasses() {
    const classList = [this._width, this._height, this.inlineBlockClass, this.vMiddleClass, this.class];
    return classList;
  }

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    @Attribute('aria-hidden') ariaHidden: string,
    private iconService: IconService
  ) {
    // If the user has not explicitly set aria-hidden, mark the icon as hidden, as this is
    // the right thing to do for the majority of icon use-cases.
    if (!ariaHidden) {
      elementRef.nativeElement.setAttribute('aria-hidden', 'true');
    }
  }

  ngOnInit() {
    this._width = this.width;
    this._height = this.height;
    if (isNone(this._name)) {
      const message = `sml-icon must have an icon name, ex: <sml-icon name="home"></sml-icon>`;
      if (isDevMode()) {
        throw new Error(message);
      }
      console.error(message);
    }
  }

  @Input() set name(value: string) {
    this._name = Some(value);
    this.setSvgElement(value);
  }

  private setSvgElement(name: string) {
    this.clearSvgElement();
    const svg = this.iconService.makeSvg(name);
    this.elementRef.nativeElement.appendChild(svg);
  }

  private clearSvgElement() {
    const layoutElement = this.elementRef.nativeElement;
    let childCount = layoutElement.childNodes.length;

    // Remove existing non-element child nodes and SVGs, and add the new SVG element.
    while (childCount--) {
      const child = layoutElement.childNodes[childCount];
      if (child.nodeType !== 1 || child.nodeName.toLowerCase() === 'svg') {
        child.remove();
      }
    }
  }
}


